// Debounce
export const LONG_DEBOUNCE = 500;
